const getManagersWidgets = (ctx) => {
  return {
    name: ctx.$t('stats.salesManagers'),
    rightWidgets:[
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('stats.totalPaymentsForPeriod'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'numberOfPayments',
        data: null
      },
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('stats.totalPaidForPeriod'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'sumOfPayments',
        data: null
      }]
  }
}

export default getManagersWidgets